import { Component } from '@angular/core';
import { FieldOkDefinition } from '../../../../data/definitions';
import { DynamicInputAtom } from '../dynamic-input-atom';

import { ReactiveFormsModule } from '@angular/forms';
import {
  FieldValidationDirective,
  UiCorePipesModule,
  ValueConverterDirective,
} from '@softline/ui-core';
import { BooleanRulePipe } from '../../../../pipes/boolean-rule.pipe';
import { FormControlPipe } from '../../../../pipes/form-control-name.pipe';
import { FormatRulePipe } from '../../../../pipes/format-rule.pipe';
import { ResolveParametersPipe } from '../../../../pipes/resolve-parameters.pipe';
import { ResultMappingConverterPipe } from '../../../../pipes/result-mapping-converter.pipe';
import { MultiselectFieldOkComponent } from '../../../multiselect-field-ok/multiselect-field-ok.component';

@Component({
  selector: 'soft-dynamic-multi-field-ok-input',
  templateUrl: './field-ok-input.component.html',
  styleUrls: ['./field-ok-input.component.css'],
  imports: [
    ValueConverterDirective,
    ReactiveFormsModule,
    FieldValidationDirective,
    FormControlPipe,
    BooleanRulePipe,
    ResultMappingConverterPipe,
    ResolveParametersPipe,
    FormatRulePipe,
    UiCorePipesModule,
    MultiselectFieldOkComponent,
  ],
})
export class MultiFieldOkInputComponent extends DynamicInputAtom<FieldOkDefinition> {
  constructor() {
    super();
  }
}
